module.exports = __webpack_public_path__ + "static/img/bg_card_white@2x.ff03a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourAdvantage/bg_card_white@2x.png
// module id = AxgF
// module chunks = 0